import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { DxStepperModule } from "devextreme-angular";
import { SteppedProgressBarComponent } from "./stepped-progress-bar.component";


@NgModule({
    declarations: [
        SteppedProgressBarComponent,
    ],
    imports: [
        CommonModule,
        DxStepperModule,
    ],
    exports: [
        SteppedProgressBarComponent,
    ],
})
export class AdaptSteppedProgressBarModule {}
